import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { PreviewVideoDirective } from './preview-video.directive';

@NgModule({
  imports: [CommonModule, OverlayModule, PortalModule],
  exports: [PreviewVideoDirective],
  declarations: [PreviewVideoDirective],
})
export class PreviewVideoModule {}
